module.exports = __webpack_public_path__ + "img/funGoDetailData.50ae5c2d.png";